import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AccountCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"account_circle"}/>
}
